import React from 'react';
import { RoundBlackCard } from '../classes/RoundBlackCards';

interface FaceDownCardInterface {
    roundBlackCards: RoundBlackCard[];
    roundBlackCardIdx: number;
    isJudge: boolean;
}

function FaceDownCard({roundBlackCards, roundBlackCardIdx, isJudge}: FaceDownCardInterface) {
    const logoBlack = require("../images/logoBlack.png");

    const handleOpenBlackCard = async (idx: number) => {
        if (isJudge && idx < roundBlackCards.length) {
            await RoundBlackCard.updateRoundBlackCardIsOpen(roundBlackCards[idx].player);
        }
    }

    return (
        <div className="faceDownCardWrapper" style={{cursor: `${isJudge ? "pointer" : "default"}`}} tabIndex={0} onClick={() => handleOpenBlackCard(roundBlackCardIdx)} onKeyDown={(e) => {
            if (e.key === "Enter") {
                handleOpenBlackCard(roundBlackCardIdx);
            }
        }}>
            <img className="faceDownCardLogo" src={logoBlack} alt="logo"/>
            {isJudge && <div className="faceDownCardClickText">Click to view</div>}
        </div>
    );
};

export default FaceDownCard;